module.exports = __webpack_public_path__ + "img/ce92719.png";